// web/src/lib/email-templates.ts
import { apiFetch } from "./api";
import type { PagedResult } from "./clients-accounts";

export interface EmailTemplateDto {
  id: number;
  name: string;
  subject: string;
  htmlBody: string;
  sortOrder: number;
  createdOn: string | null;
  createdByName: string | null;
  modifiedOn: string | null;
  modifiedByName: string | null;
  deleted: boolean;
  templateKey?: string | null;
  inlineImageManifestJson?: string | null;
}

export interface CreateEmailTemplateRequest {
  name: string;
  subject: string;
  htmlBody: string;
  sortOrder?: number | null;
  templateKey?: string | null;
  /** Task B4 — serialized `{cid, assetId}[]` manifest for images inserted "from library". */
  inlineImageManifestJson?: string | null;
}

export interface UpdateEmailTemplateRequest {
  name: string;
  subject: string;
  htmlBody: string;
  sortOrder?: number | null;
  deleted: boolean;
  templateKey?: string | null;
  /** Task B4 — serialized `{cid, assetId}[]` manifest for images inserted "from library". */
  inlineImageManifestJson?: string | null;
}

export interface EmailTemplateCatalogEntry {
  templateKey: string;
  tokens: { name: string; description: string; sampleValue: string; raw: boolean }[];
  hasOverride: boolean;
}

export interface EmailTemplateHistory {
  auditLogId: number;
  timestampUtc: string;
  byName: string | null;
  subject: string;
  bodySnippet: string;
}

export const emailTemplatesApi = {
  list: (page = 0, pageSize = 50, includeDeleted = false) =>
    apiFetch<PagedResult<EmailTemplateDto>>(
      `/api/email-templates?page=${page}&pageSize=${pageSize}&deleted=${includeDeleted}`,
    ),
  get: (id: number) =>
    apiFetch<EmailTemplateDto>(`/api/email-templates/${id}`),
  create: (body: CreateEmailTemplateRequest) =>
    apiFetch<EmailTemplateDto>("/api/email-templates", {
      method: "POST", body: JSON.stringify(body),
    }),
  patch: (id: number, body: UpdateEmailTemplateRequest) =>
    apiFetch<EmailTemplateDto>(`/api/email-templates/${id}`, {
      method: "PATCH", body: JSON.stringify(body),
    }),
  delete: (id: number) =>
    apiFetch<void>(`/api/email-templates/${id}`, { method: "DELETE" }),
  catalog: () =>
    apiFetch<EmailTemplateCatalogEntry[]>("/api/email-templates/catalog"),
  preview: (id: number, body: { sampleEntityId?: number | null }) =>
    apiFetch<{ subject: string; htmlBody: string }>(`/api/email-templates/${id}/preview`, {
      method: "POST", body: JSON.stringify(body),
    }),
  history: (id: number) =>
    apiFetch<EmailTemplateHistory[]>(`/api/email-templates/${id}/history`),
  restore: (id: number, auditLogId: number) =>
    apiFetch<void>(`/api/email-templates/${id}/restore/${auditLogId}`, { method: "POST" }),
};
